
define('text!templates/topic_viewers.html',[],function () { return '<p class="container" style="text-align:left">\n    <span style="font-weight:bold"><%=title%></span> (<%=guestTitle%>: <%=guestsCount%>, <%=usersTitle%>: <%=usersCount%>)\n    <% for (var i = 0; i < users.length; i++) {%>\n        <a href="/profile.php?id=<%=users[i].id%>"><%=users[i].username%></a>\n    <% } %>\n</p>\n';});

